export enum GENERAL_JOURNAL_SOURCE {
  MANUAL = "Manual",
  TRANSACTIONAL = "Transactional"
}

export enum GENERAL_JOURNAL_STATUS {
  POSTED = "Posted",
  SUBMITTED = "Submitted",
}
